export var FinanceRoutes;
(function (FinanceRoutes) {
    FinanceRoutes["FINANCE"] = "finance";
})(FinanceRoutes || (FinanceRoutes = {}));
